import React from 'react';
import { Container, Card, Accordion, Button, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, ExternalLink } from 'lucide-react';

const WhatsAppHelpPage = () => {
    const navigate = useNavigate();

    return (
        <Container className="p-4">
            <Button variant="link" onClick={() => navigate('/whatsapp')} className="mb-3 ps-0 text-decoration-none d-flex align-items-center gap-2">
                <ArrowLeft size={20} /> Voltar para Configuração
            </Button>

            <h2 className="mb-4">Guia de Configuração - WhatsApp Business API</h2>

            <Alert variant="info">
                Para integrar o Y-Agenda ao WhatsApp, você precisa de uma conta no <strong>Meta for Developers</strong> e uma <strong>WhatsApp Business Account (WABA)</strong>.
            </Alert>

            <Accordion defaultActiveKey="0" className="mb-5">
                <Accordion.Item eventKey="0">
                    <Accordion.Header>Passo 1: Criar App no Meta Developers</Accordion.Header>
                    <Accordion.Body>
                        <ol>
                            <li>Acesse o <a href="https://developers.facebook.com/" target="_blank" rel="noreferrer">Meta for Developers <ExternalLink size={14} /></a> e faça login.</li>
                            <li>Vá em "Meus Apps" e clique em <strong>Criar App</strong>.</li>
                            <li>Selecione o tipo <strong>"Outro"</strong> (ou "Empresa").</li>
                            <li>Selecione <strong>"Empresa"</strong> como tipo de aplicativo.</li>
                            <li>Preencha o nome do App (ex: "Y-Agenda Integration") e crie o app.</li>
                        </ol>
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                    <Accordion.Header>Passo 2: Adicionar Produto WhatsApp</Accordion.Header>
                    <Accordion.Body>
                        <ol>
                            <li>No painel do app, procure por "WhatsApp" e clique em <strong>Configurar</strong>.</li>
                            <li>Selecione (ou crie) uma conta empresarial (Meta Business Account).</li>
                            <li>Após configurar, você verá a seção "API de Configuração" no menu lateral esquerdo (WhatsApp {'>'} Configuração da API).</li>
                        </ol>
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                    <Accordion.Header>Passo 3: Obter Credenciais</Accordion.Header>
                    <Accordion.Body>
                        <p>Na tela "Configuração da API" do WhatsApp:</p>
                        <ul>
                            <li><strong>Phone Number ID:</strong> Copie o "Identificação do número de telefone".</li>
                            <li><strong>Token de Acesso:</strong>
                                <ul>
                                    <li>Para testes: Copie o "Token de acesso temporário".</li>
                                    <li>Para produção: É necessário criar um "Usuário do Sistema" no Business Manager e gerar um token permanente.</li>
                                </ul>
                            </li>
                        </ul>
                        <p className="text-muted">Cole esses valores na tela de configuração do Y-Agenda.</p>
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="3">
                    <Accordion.Header>Passo 4: Configurar Webhook</Accordion.Header>
                    <Accordion.Body>
                        <ol>
                            <li>No menu lateral do Meta, vá em <strong>WhatsApp {'>'} Configuração</strong>.</li>
                            <li>Em "Webhook", clique em <strong>Editar</strong>.</li>
                            <li>
                                <strong>URL de Retorno de Chamada:</strong> Insira a URL da sua API:
                                <code> https://seu-dominio.com/api/whatsapp/webhook/</code>
                            </li>
                            <li>
                                <strong>Token de Verificação:</strong> Crie uma senha (ex: "yagenda_secret") e insira aqui.
                                <br /><em>Importante: Insira a MESMA senha no campo "Verification Token" do Y-Agenda.</em>
                            </li>
                            <li>Clique em "Verificar e Salvar".</li>
                            <li>Após salvar, clique em "Gerenciar" (Manage) nos campos do Webhook e inscreva-se em <strong>messages</strong>.</li>
                        </ol>
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="4">
                    <Accordion.Header>Passo 5: Criar Templates (Opcional)</Accordion.Header>
                    <Accordion.Body>
                        <p>Para iniciar conversas (notificações), o WhatsApp exige Templates aprovados.</p>
                        <ol>
                            <li>No Gerenciador do WhatsApp, vá em "Modelos de Mensagem".</li>
                            <li>Crie um modelo para Login (ex: <code>auth_login</code>) com o corpo: <br /><code>"Seu link de acesso: {'{{1}}'}"</code>.</li>
                            <li>Crie um modelo para Confirmação (ex: <code>booking_conf</code>).</li>
                            <li>Após aprovados, copie os <strong>nomes</strong> e insira na configuração do Y-Agenda.</li>
                        </ol>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </Container>
    );
};

export default WhatsAppHelpPage;
